module.exports = __webpack_public_path__ + "static/img/team_make.451708d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/team_make.png
// module id = tBXN
// module chunks = 1